import { ApolloClient, NormalizedCacheObject, useQuery } from '@apollo/client';

import POSTS_QUERY_WITH_TOTAL_COUNT from 'graphql/post/queries/postsWithMeta.graphql';

import type {
  GetPostsWithTotalCountQuery,
  GetPostsWithTotalCountQueryVariables,
} from 'graphql/types';

export const usePostsWithTotalCount = (
  variables?: GetPostsWithTotalCountQueryVariables
) =>
  useQuery<GetPostsWithTotalCountQuery>(POSTS_QUERY_WITH_TOTAL_COUNT, {
    variables,
  });

export const getPostsWithTotalCountSsr = async (
  client: ApolloClient<NormalizedCacheObject>,
  variables?: GetPostsWithTotalCountQueryVariables
) => {
  try {
    return client.query({
      query: POSTS_QUERY_WITH_TOTAL_COUNT,
      variables,
    });
  } catch (err) {
    console.log(err);
  }
};
